import { User } from './types';
import { AuthenticationClient } from './client';

function isAuthenticated(): boolean {
  return AuthenticationClient.getInstance().isAuthenticated();
}

function getAccessToken(ignoreCache?: boolean): Promise<string> {
  return AuthenticationClient.getInstance().getAccessToken(ignoreCache);
}

function getUser(): User | null {
  return AuthenticationClient.getInstance().getUser();
}

function getError(): Error | null {
  return AuthenticationClient.getInstance().getError();
}

export const authentication = {
  isAuthenticated,
  getAccessToken,
  getUser,
  getError,
};
